module.exports = __webpack_public_path__ + "static/media/partner_cookina.91bb7ba6.jpg";